import List from "./components/List"
import Form from "./components/Form"

let module = "modules"

export default [
  {
    path: "modules",
    component: List,
    meta: { module: module, permissions: ["module-access"] }
  },
  {
    path: "modules/create",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["module-create"] }
  },
  {
    path: "modules/edit/:id",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["module-edit"] }
  }
]
